import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { FlyDeltaPoll, OauthAEMConfig } from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class FlyDeltaPollService {
  flyDetlaPollHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.poll+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitFlyDeltaPoll = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<FlyDeltaPoll> => {
    const flyDeltaPollUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitFlyDeltaPollMfaUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: flyDeltaPollUrl
      }
    ];

    return new ApiBuilder<undefined, FlyDeltaPoll>(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitFlyDeltaPollMfaUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.flyDetlaPollHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_FLY_DELTA_POLL_SERVICE')
      .withCredentials(true)
      .create();
  };
}
